import z from 'zod';

import { attachmentItemSchema } from './attachmentItem.schema';

export const attachmentsSchema = z.array(attachmentItemSchema).optional();
